import Image from 'next/image';

import styles from './business-hub-footer-top.module.scss';
import BusinessButton from '../business-button/business-button';
import { FC, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { Locale, useLocale } from '../../helpers/LangHelper';
import { BuilderContent } from '@builder.io/react';

interface Props {
    theme?: 'light' | 'dark';
    ctaLink?: string;
    page: any;
}

export const BusinessHubFooterTop: FC<Props> = (props) => {
    const { theme, ctaLink, page } = props;

    const { locale } = useLocale();
    const [endCap, setEndCap] = useState<string>();

    useEffect(() => {
        switch (locale) {
            case Locale.GreatBritain:
                setEndCap('https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2Fb253e0e1fcae476a8d01f677ae08e7ee');
                break;
            case Locale.NewZealand:
            case Locale.USA:
                setEndCap('https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F2b0bdaff206d46fa958563231183514a');
                break;
            default:
                setEndCap('https://cdn.builder.io/api/v1/image/assets%2F035a3d41874344d79b6c7499e2e7a5bc%2F442c1a97e9594574b74bc8c4a92ecd42');
                break;
        }
    }, [locale]);

    const title = useMemo(() => {
        switch (locale) {
            case Locale.GreatBritain:
            case Locale.USA:
                return (
                    <div className={styles.title}>
                        Say hello to&nbsp;
                        <br className={styles.mobileBr} />
                        24 million
                        <span className="footer-asterisk" />
                        &nbsp;
                        <br />
                        active global&nbsp;
                        <br />
                        customers today.
                    </div>
                );

            default:
                return (
                    <div className={styles.title}>
                        Say hello to&nbsp;
                        <br className={styles.mobileBr} />
                        4.4 million
                        <span className="footer-caret" />
                        &nbsp;
                        <br />
                        active Afterpay&nbsp;
                        <br />
                        consumers today.
                    </div>
                );
        }
    }, [locale]);

    return (
        <div className={classNames(styles.container, { [styles['--light']]: theme === 'light' })}>
            <div className={styles.content}>
                <div className={styles.left}>
                    {title}
                    <div className={styles.description}>
                        <ul>
                            <li>
                                <span>•</span>
                                <span>Simple and easy sign up.</span>
                            </li>
                            <li>
                                <span>•</span>
                                <span>Easy integration.</span>
                            </li>
                            <li>
                                <span>•</span>
                                <span>Clear and transparent pricing.</span>
                            </li>
                        </ul>
                    </div>

                    <BusinessButton link={ctaLink} className={styles.button} buttonText="Get started" target="_blank" />
                </div>
                <div className={styles.right}>
                    <div className={styles.rightBox}>
                        {endCap ? (
                            <Image
                                src={endCap}
                                alt=""
                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                fill={true}
                                loading={'eager'}
                                loader={({ src, width, quality }) => {
                                    return `${src}?width=${width}&quality=${quality ?? 75}`;
                                }}
                                sizes="(max-width: 638px) 98vw,  (max-width: 998px) 43vw, 46vw"
                                className={styles.image}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};
